import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { IGKLekkasjetestResultater, IGKRapport } from "@mcapps/shared/reportSchemas/gkReportSchema";
import { Radio, Paper, Stack, Title, Box, Flex } from "@mantine/core";
const Lekkasjetest: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKLekkasjetestResultater;
}> = ({ data, onUpdateEditData }) => {
  const updateMaaleresultater = (resultat: string | number, i: number, parameter: string) => {
    const maaleresultater = [...data.inndata.maaleresultater];
    maaleresultater[i][parameter] = resultat;
    onUpdateEditData("testResultater.lekkasjetest.inndata.maaleresultater", maaleresultater);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Lekkasjetest
        </Title>
        <div style={{ marginTop: 0, display: "flex", flexDirection: "column", width: "50%" }}>
          <b>Fyll inn måleresultater:</b>
          <table>
            <thead>
              <tr>
                <th>Starttrykk &#40;Pa&#41;</th>
                <th>Sluttrykk &#40;Pa&#41;</th>
              </tr>
            </thead>
            {data.inndata.maaleresultater.map((resultat, i) => (
              <tbody key={i}>
                <tr>
                  <td>
                    <McInputNew
                      value={resultat.starttrykk}
                      normalizeNumbers={true}
                      type="text"
                      onBlur={(e) => updateMaaleresultater(Number(e.target.value), i, "starttrykk")}
                      placeholder="Starttrykk"
                    />
                  </td>
                  <td>
                    <McInputNew
                      value={resultat.sluttrykk}
                      normalizeNumbers={true}
                      type="text"
                      onBlur={(e) => updateMaaleresultater(Number(e.target.value), i, "sluttrykk")}
                      placeholder="Sluttrykk"
                    />
                  </td>
                </tr>
              </tbody>
            ))}
          </table>
        </div>
        <div>
          <Flex direction="column" mt="lg">
            <Radio
              checked={data.inndata.godkjent === true}
              onChange={() => onUpdateEditData("testResultater.lekkasjetest.inndata.godkjent", true)}
              label="Godkjent"
            />
            <Radio
              checked={data.inndata.godkjent === false}
              onChange={() => onUpdateEditData("testResultater.lekkasjetest.inndata.godkjent", false)}
              label="Ikke godkjent"
            />
          </Flex>
        </div>
        <Box mt="lg" style={{ width: "50%" }}>
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) => onUpdateEditData("testResultater.lekkasjetest.inndata.kommentar", e.target.value)}
          />
        </Box>
      </Stack>
    </Paper>
  );
};
export default Lekkasjetest;
